import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { LogOut, ChevronRight } from 'lucide-react';
import { Navigate } from 'react-router-dom';

const SettingsView: React.FC = () => {
  const { logout, user, loading } = useAuth();

  if (loading) return <div className="min-h-[50vh] flex items-center justify-center">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="max-w-2xl mx-auto py-8 px-4">
      <h2 className="font-heading text-xl tracking-widest mb-8 border-b border-gray-100 pb-4">SETTINGS</h2>
      
      <div className="space-y-6">
        <section>
          <h3 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4">Account</h3>
          <div className="bg-gray-50 p-4 rounded-sm flex justify-between items-center">
             <div>
               <p className="font-heading font-bold text-sm">EMAIL ADDRESS</p>
               <p className="font-body text-sm text-gray-600">{user?.email}</p>
             </div>
             <button className="text-xs font-bold underline">EDIT</button>
          </div>
        </section>

        <section>
          <h3 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4">Preferences</h3>
          <div className="space-y-2">
            {['Notifications', 'Privacy', 'Language'].map(item => (
              <button key={item} className="w-full flex justify-between items-center p-4 bg-white border border-gray-100 hover:bg-gray-50 transition-colors">
                <span className="font-heading text-sm uppercase tracking-wide">{item}</span>
                <ChevronRight size={16} className="text-gray-400" />
              </button>
            ))}
          </div>
        </section>

        <section>
           <button 
             onClick={logout}
             className="w-full py-4 border border-black text-black font-heading font-bold tracking-widest hover:bg-black hover:text-white transition-colors flex items-center justify-center gap-2"
           >
             <LogOut size={18} /> SIGN OUT
           </button>
           <p className="text-center text-xs text-gray-400 mt-4">Version 2.0.0</p>
        </section>
      </div>
    </div>
  );
};

export default SettingsView;
